export default __webpack_public_path__ + "static/media/acceptImg.67cbb013.svg";